
import React, { Component } from 'react';

class HeaderIconsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className="header-itens-align-right">

        {/*
        <input className="form-control mr-sm-2" type="search" placeholder="Buscar" aria-label="Search" />

        <button
          type="button"
          className="btn-not-styled"
        >
          <i className="fas fa-search-dollar" value="open" />
        </button>

        <button type="button" className="btn-not-styled">
          <i className="fas fa-cubes" value="open" />
        </button>
        <button type="button" className="btn-not-styled">
          <i className="fas fa-bullhorn" />
        </button>
        <button type="button" className="btn-not-styled">
          <i className="far fa-bell" />
        </button>
       */}


      </div>
    );
  }
}

export default HeaderIconsComponent;
